// extracted by mini-css-extract-plugin
export default {"select":"CrashesVersionSelect_select__OBAQu","queryText":"CrashesVersionSelect_queryText__+YsE9"};